import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

const initState = {
  workers: null,
  unassignObjectIds: {},
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const workers = data;
  const unassignObjectIds = {};
  workers.forEach(item => {
    unassignObjectIds[item.id] = false;
  });

  return {
    ...state,
    workers,
    unassignObjectIds,
    loading: false,
  };
}

function onChangeChecked(state, { payload }) {
  const { id, value } = payload;
  const { unassignObjectIds } = state;

  if (id === 'all') {
    Object.keys(unassignObjectIds).forEach(propId => {
      unassignObjectIds[propId] = value;
    });
  } else {
    unassignObjectIds[id] = value;
  }

  return {
    ...state,
    unassignObjectIds,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_CHECKED]: onChangeChecked,
});
